import React from "react";

import styles from "./heading.module.css";

const Heading = ({
  txt,
  fontSize,
  fontWeight,
  paddingTop,
  paddingBottom,
  paddingRight,
  icon,
  details,
  toggleDetailsDialogHandler,
  new_styles,
  view,
  customHeadingClass,
}) => {
  return (
    <>
      <p
        className={`${styles.heading} ${customHeadingClass}`}
        style={{
          fontSize,
          fontWeight,
          paddingTop,
          paddingBottom,
          paddingRight,
          ...new_styles,
        }}
      >
        {txt}
      </p>

      {icon && txt ? (
        <img
          className={styles.information_icon}
          src={`/img/info_icons/${icon}`}
          onClick={() =>
            toggleDetailsDialogHandler(true, {
              EntertainmentPublished: details.title,
              ActDescription: details.longDesc,
              Images: details.images,
              Details: details.details,
            })
          }
          alt=""
        />
      ) : (
        <>
          {view === "Entertainments" ? (
            <div style={{ height: "55px" }}></div>
          ) : null}
        </>
      )}
    </>
  );
};

export default Heading;
